import { SupportedLocales } from '@/models/localization.model';
import { IProduct } from '@/models/products.model';

type ProductPriceFields = IProduct & {
  price?: number | string | null;
  discount_price?: number | string | null;
};

/** Admin `IProduct` omits prices in types; API may still return them for preview. */
export function pickProductCardPreviewPrices(product: IProduct): { current: string; old?: string } | null {
  const p = product as ProductPriceFields;
  const rawPrice = p.price;
  const rawDisc = p.discount_price;
  if (rawPrice == null && rawDisc == null) return null;
  const priceNum = rawPrice != null ? Number(rawPrice) : NaN;
  const discNum = rawDisc != null ? Number(rawDisc) : NaN;
  const hasDiscount = !Number.isNaN(priceNum) && !Number.isNaN(discNum) && discNum < priceNum && discNum >= 0;
  if (hasDiscount) {
    return { current: String(rawDisc), old: String(rawPrice) };
  }
  return { current: String(rawDisc ?? rawPrice ?? '') };
}

export const pickLocalizedString = (value: unknown, locale: SupportedLocales, fallback = ''): string => {
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const m = value as Record<string, string>;
    return m[locale] ?? Object.values(m).find((s) => typeof s === 'string' && s) ?? fallback;
  }
  return fallback;
};

export const pickLocalizedLines = (value: unknown, locale: SupportedLocales): string[] => {
  if (Array.isArray(value) && value.every((v) => typeof v === 'string')) {
    return value as string[];
  }
  if (!value || typeof value !== 'object' || Array.isArray(value)) return [];
  const m = value as Record<string, string[]>;
  return m[locale] ?? m[Object.keys(m)[0]] ?? [];
};

export const getGalleryRowsFromBlockData = (data: unknown): unknown[] => {
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const items = (data as Record<string, unknown>).items;
    if (Array.isArray(items)) return items;
  }
  return [];
};
